
export class RelatedUnit {

    constructor(title, inputs, columns) {
        this.title = title;
        this.inputs = inputs;
        this.columns = columns;
    }
}
